import(/* webpackMode: "eager" */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/app/[locale]/search/page.tsx");
